(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collage-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__collageGridLayoutBound) return;
    window.__collageGridLayoutBound = true;

    const desktopQuery = window.matchMedia('(min-width: 750px)');

    const imageSelector = '.card-gallery img.product-media__image, img.image-block__image';
    const sizeImage = (image) => {
      const { width, height } = image.getBoundingClientRect();
      if (width <= 0 || height <= 0) return;

      // A square source cropped into a portrait tile needs pixels for its full
      // scaled width (tile height), not just the visible width. Leave DPR to the
      // browser's native srcset selection; never multiply sizes by DPR here.
      const sourceWidth = Number(image.getAttribute('width'));
      const sourceHeight = Number(image.getAttribute('height'));
      const ratio = sourceWidth > 0 && sourceHeight > 0 ? sourceWidth / sourceHeight : 1;
      const fit = getComputedStyle(image).objectFit;
      const sourceSize = fit === 'cover' ? Math.max(width, height * ratio) : width;
      const sizes = `${Math.ceil(sourceSize)}px`;
      if (image.sizes !== sizes) image.sizes = sizes;
    };

    const observeImages = (grid) => {
      if (!grid.__collageImageObserver) {
        grid.__collageImageObserver = new ResizeObserver((entries) => {
          entries.forEach(({ target }) => sizeImage(target));
        });
        grid.__collageImages = new Set();
        grid.addEventListener('load', (event) => {
          if (event.target.matches?.(imageSelector)) sizeImage(event.target);
        }, true);
      }
      grid.__collageImages.forEach((image) => {
        if (!grid.contains(image)) {
          grid.__collageImageObserver.unobserve(image);
          grid.__collageImages.delete(image);
        }
      });
      grid.querySelectorAll(imageSelector).forEach((image) => {
        if (!grid.__collageImages.has(image)) {
          grid.__collageImages.add(image);
          grid.__collageImageObserver.observe(image);
        }
        sizeImage(image);
      });
    };

    const isCollageBlock = (element) => {
      // product-card-link wraps product-card since the product-card block
      // update (Update from Shopify, July 2026); match both.
      return element.matches(
        'product-card, product-card-link, .image-block, a.image-block, deferred-media, .video-placeholder-wrapper'
      );
    };

    const resetGridPlacement = (blocks) => {
      blocks.forEach((block) => {
        block.style.gridColumn = '';
        block.style.gridRow = '';
      });
    };

    const applyGridPlacement = (grid) => {
      const blocks = Array.from(grid.children).filter(isCollageBlock);
      const layout = grid.dataset.desktopLayout;
      const mobileLayout = grid.dataset.mobileLayout;

      resetGridPlacement(blocks);

      // Markup changes must never take the whole layout down; the 3-block
      // branches below index blocks[1]/blocks[2] directly.
      if (blocks.length === 0) return;

      if (!desktopQuery.matches) {
        if (mobileLayout !== 'collage') return;

        if (blocks.length === 1) {
          blocks[0].style.gridColumn = '1 / span 2';
          blocks[0].style.gridRow = '1';
          return;
        }

        if (blocks.length === 2) {
          if (layout === 'right') {
            blocks[0].style.gridColumn = '1 / span 2';
            blocks[0].style.gridRow = '1';
            blocks[1].style.gridColumn = '1 / span 2';
            blocks[1].style.gridRow = '2';
          } else {
            blocks[0].style.gridColumn = '1 / span 2';
            blocks[0].style.gridRow = '1';
            blocks[1].style.gridColumn = '1 / span 2';
            blocks[1].style.gridRow = '2';
          }
          return;
        }

        if (layout === 'right') {
          blocks[0].style.gridColumn = '1';
          blocks[0].style.gridRow = '1';
          blocks[1].style.gridColumn = '2';
          blocks[1].style.gridRow = '1';
          blocks[2].style.gridColumn = '1 / span 2';
          blocks[2].style.gridRow = '2';
        } else {
          blocks[0].style.gridColumn = '1 / span 2';
          blocks[0].style.gridRow = '1';
          blocks[1].style.gridColumn = '1';
          blocks[1].style.gridRow = '2';
          blocks[2].style.gridColumn = '2';
          blocks[2].style.gridRow = '2';
        }

        return;
      }

      if (blocks.length === 1) {
        blocks[0].style.gridColumn = '1 / span 3';
        blocks[0].style.gridRow = '1 / span 2';
        return;
      }

      if (blocks.length === 2) {
        if (layout === 'right') {
          blocks[0].style.gridColumn = '1';
          blocks[0].style.gridRow = '1 / span 2';
          blocks[1].style.gridColumn = '2 / span 2';
          blocks[1].style.gridRow = '1 / span 2';
        } else {
          blocks[0].style.gridColumn = '1 / span 2';
          blocks[0].style.gridRow = '1 / span 2';
          blocks[1].style.gridColumn = '3';
          blocks[1].style.gridRow = '1 / span 2';
        }
        return;
      }

      if (layout === 'right') {
        blocks[0].style.gridColumn = '1';
        blocks[0].style.gridRow = '1';
        blocks[1].style.gridColumn = '1';
        blocks[1].style.gridRow = '2';
        blocks[2].style.gridColumn = '2 / span 2';
        blocks[2].style.gridRow = '1 / span 2';
      } else {
        blocks[0].style.gridColumn = '1 / span 2';
        blocks[0].style.gridRow = '1 / span 2';
        blocks[1].style.gridColumn = '3';
        blocks[1].style.gridRow = '1';
        blocks[2].style.gridColumn = '3';
        blocks[2].style.gridRow = '2';
      }
    };

    const applyAllCollageGrids = (root = document) => {
      root.querySelectorAll('[data-testid="collage-grid"] .collage-grid').forEach((grid) => {
        applyGridPlacement(grid);
        observeImages(grid);

        if (!grid.__collageObserver) {
          grid.__collageObserver = new MutationObserver(() => {
            applyGridPlacement(grid);
            observeImages(grid);
          });
          grid.__collageObserver.observe(grid, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['width', 'height', 'srcset'],
          });
        }
      });
    };

    document.addEventListener('DOMContentLoaded', () => applyAllCollageGrids(), { once: true });
    document.addEventListener('shopify:section:load', (event) => applyAllCollageGrids(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('.collage-grid').forEach((grid) => {
        grid.__collageObserver?.disconnect();
        grid.__collageImageObserver?.disconnect();
      });
    });
    document.addEventListener('shopify:section:reorder', () => applyAllCollageGrids());
    document.addEventListener('shopify:block:select', () => applyAllCollageGrids());
    document.addEventListener('shopify:block:deselect', () => applyAllCollageGrids());
    desktopQuery.addEventListener('change', () => applyAllCollageGrids());

    applyAllCollageGrids();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const pendingHeightTransitions = new WeakMap();

    function clearHeightTransition(panel) {
      const pending = pendingHeightTransitions.get(panel);
      if (!pending) return;
      panel.removeEventListener('transitionend', pending.handler);
      clearTimeout(pending.timeout);
      pendingHeightTransitions.delete(panel);
    }

    function afterHeightTransition(panel, finish) {
      const complete = () => {
        clearHeightTransition(panel);
        finish();
      };
      const handler = (event) => {
        if (event.target !== panel || event.propertyName !== 'height') return;
        complete();
      };
      panel.addEventListener('transitionend', handler);
      const timeout = setTimeout(complete, 250);
      pendingHeightTransitions.set(panel, { handler, timeout });
    }

    function closeItem(item) {
      const button = item?.querySelector('[data-dynamic-faq-button]');
      const panel = item?.querySelector('[data-dynamic-faq-panel]');
      if (!button || !panel || panel.hidden) return;

      clearHeightTransition(panel);
      panel.style.height = `${panel.offsetHeight}px`;
      panel.style.opacity = '1';
      item.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        panel.hidden = true;
        panel.style.height = '';
        panel.style.opacity = '';
        return;
      }

      requestAnimationFrame(() => {
        panel.style.height = '0px';
        panel.style.opacity = '0';
      });

      afterHeightTransition(panel, () => {
        panel.hidden = true;
        panel.style.height = '';
        panel.style.opacity = '';
      });
    }

    function openItem(item) {
      const button = item?.querySelector('[data-dynamic-faq-button]');
      const panel = item?.querySelector('[data-dynamic-faq-panel]');
      const panelInner = item?.querySelector('[data-dynamic-faq-panel-inner]');
      if (!button || !panel || !panelInner) return;

      clearHeightTransition(panel);
      item.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      panel.style.height = '0px';
      panel.style.opacity = '0';

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        panel.style.height = 'auto';
        panel.style.opacity = '1';
        return;
      }

      requestAnimationFrame(() => {
        panel.style.height = `${panelInner.offsetHeight}px`;
        panel.style.opacity = '1';
      });

      afterHeightTransition(panel, () => {
        panel.style.height = 'auto';
      });
    }

    function initDynamicFaq(section) {
      if (!section || section.dataset.dynamicFaqReady === 'true') return;
      section.dataset.dynamicFaqReady = 'true';

      section.addEventListener('click', (event) => {
        const button = event.target.closest('[data-dynamic-faq-button]');
        if (!button) return;

        const item = button.closest('[data-dynamic-faq-item]');
        if (!item) return;
        const isOpen = item.classList.contains('is-open');

        section.querySelectorAll('[data-dynamic-faq-item].is-open').forEach((openItem) => {
          if (openItem !== item) closeItem(openItem);
        });

        if (isOpen) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    }

    document.querySelectorAll('[data-dynamic-faq-section]').forEach(initDynamicFaq);
    document.addEventListener('shopify:section:load', (event) => initDynamicFaq(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metaobject-country-makers"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function updateCountryMakersSlider(section) {
      const track = section.querySelector('[data-country-makers-track]');
      const prev = section.querySelector('[data-country-makers-prev]');
      const next = section.querySelector('[data-country-makers-next]');
      const current = section.querySelector('[data-country-makers-current]');
      if (!track || !prev || !next || !current) return;

      const items = [...track.querySelectorAll('.metaobject-country-makers__item')];
      if (!items.length) return;

      const firstVisibleIndex = items.findIndex((item) => {
        const rect = item.getBoundingClientRect();
        const trackRect = track.getBoundingClientRect();
        return rect.left >= trackRect.left - 4;
      });
      const index = firstVisibleIndex >= 0 ? firstVisibleIndex : 0;
      current.textContent = String(index + 1);
      prev.disabled = track.scrollLeft <= 4;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
    }

    function initCountryMakers(section) {
      const track = section.querySelector('[data-country-makers-track]');
      const prev = section.querySelector('[data-country-makers-prev]');
      const next = section.querySelector('[data-country-makers-next]');
      if (!track || !prev || !next || track.dataset.countryMakersReady === 'true') return;
      track.dataset.countryMakersReady = 'true';

      const getStep = () => {
        const item = track.querySelector('.metaobject-country-makers__item');
        if (!item) return track.clientWidth;
        const style = window.getComputedStyle(track);
        const gap = parseFloat(style.columnGap || style.gap || '0');
        return item.getBoundingClientRect().width + gap;
      };

      prev.addEventListener('click', () => {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', () => updateCountryMakersSlider(section), { passive: true });
      window.addEventListener('resize', () => updateCountryMakersSlider(section));
      updateCountryMakersSlider(section);
    }

    const boot = (scope = document) => {
      scope.querySelectorAll('.metaobject-country-makers').forEach(initCountryMakers);
    };

    document.addEventListener('DOMContentLoaded', () => boot(document));
    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metaobject-country-overview"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function syncCountryOverviewTitleHeights(scope = document) {
      scope.querySelectorAll('[data-country-overview-grid]').forEach((grid) => {
        if (!grid.classList.contains('metaobject-country-overview__grid--two')) return;
        if (grid.closest('.metaobject-country-overview__layout--has-media')) return;

        const titleWraps = [...grid.querySelectorAll('[data-country-overview-title-wrap]')];

        titleWraps.forEach((wrap) => {
          wrap.style.minHeight = '';
        });

        if (window.innerWidth < 990 || titleWraps.length < 2) return;

        const heights = titleWraps.map((wrap) => wrap.getBoundingClientRect().height);
        const maxHeight = Math.max(...heights);
        const minHeight = Math.min(...heights);

        if (maxHeight - minHeight < 8) return;

        titleWraps.forEach((wrap) => {
          wrap.style.minHeight = `${maxHeight}px`;
        });
      });
    }

    let resizeFrame = null;

    function onResize() {
      if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(() => syncCountryOverviewTitleHeights());
    }

    document.addEventListener('DOMContentLoaded', () => syncCountryOverviewTitleHeights());
    window.addEventListener('load', () => syncCountryOverviewTitleHeights());
    document.addEventListener('shopify:section:load', (event) => syncCountryOverviewTitleHeights(event.target));
    window.addEventListener('resize', onResize);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => syncCountryOverviewTitleHeights());
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metaobject-products-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const CATALOG_PAGE_SIZE = 250;
    const CACHE_VERSION = 'native-card-controls-v3';
    const catalogCaches = window.__metaobjectProductsCatalogCache || (window.__metaobjectProductsCatalogCache = new Map());
    const catalogCache = catalogCaches.get(CACHE_VERSION) || new Map();
    if (!catalogCaches.has(CACHE_VERSION)) catalogCaches.set(CACHE_VERSION, catalogCache);
    const SESSION_PREFIX = `metaobject-products-grid::horizon::${CACHE_VERSION}::`;
    const CATALOG_STORAGE_PREFIX = `metaobject-products-catalog::horizon::${CACHE_VERSION}::`;
    const CATALOG_STORAGE_TTL_MS = 20 * 60 * 1000;

    function normalizeHandle(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function escapeHtml(value) {
      return String(value ?? '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#39;');
    }

    function parseJsonElement(element) {
      try {
        return JSON.parse(element?.textContent || '[]');
      } catch (error) {
        return [];
      }
    }

    function initGrid(root) {
      if (!root || root.dataset.metaobjectProductsReady === 'true') return;
      root.dataset.metaobjectProductsReady = 'true';

      const itemsElement = root.querySelector('[data-metaobject-products-items]');
      const statusElement = root.querySelector('[data-metaobject-products-status]');
      const emptyStateElement = root.querySelector('[data-metaobject-products-empty]');
      const paginationElement = root.querySelector('[data-metaobject-products-pagination]');
      const filtersElement = root.querySelector('[data-metaobject-products-filters]');
      const filterGroupsElement = root.querySelector('[data-metaobject-products-filter-groups]');
      const filterListElement = root.querySelector('[data-metaobject-products-filter-list]');
      const activeFiltersElement = root.querySelector('[data-metaobject-products-active-filters]');
      const drawerElement = root.querySelector('[data-metaobject-products-drawer]');
      const drawerFilterListElement = root.querySelector('[data-metaobject-products-drawer-filter-list]');
      const drawerActiveFiltersElement = root.querySelector('[data-metaobject-products-drawer-active-filters]');
      const openDrawerButton = root.querySelector('[data-metaobject-products-open-drawer]');
      const closeDrawerButton = root.querySelector('[data-metaobject-products-close-drawer]');
      const clearAllButtons = root.querySelectorAll('[data-metaobject-products-clear-all]');
      const mobileActiveCountElement = root.querySelector('[data-metaobject-products-mobile-active-count]');
      const mobileActiveCountTextElement = mobileActiveCountElement?.querySelector('.filter-count-bubble__text');
      const countWrapperElement = root.querySelector('[data-metaobject-products-count]');
      const countElement = countWrapperElement?.querySelector('span');
      const mobileCountWrapperElement = root.querySelector('[data-metaobject-products-mobile-count]');
      const mobileCountElement = mobileCountWrapperElement?.querySelector('span');
      const headingWrapper = root.querySelector('[data-metaobject-products-heading-wrapper]');
      const headingElement = root.querySelector('[data-metaobject-products-heading]');
      const defaultHeadingTemplate = root.querySelector('[data-metaobject-products-heading-default]');
      const countryOriginHeadingTemplate = root.querySelector('[data-metaobject-products-heading-country-origin]');
      const countryMakerHeadingTemplate = root.querySelector('[data-metaobject-products-heading-country-maker]');
      const debugElement = root.querySelector('[data-metaobject-products-debug]');
      const sectionContainer = root.closest('.shopify-section') || root;
      const uiConfig = parseJsonElement(root.querySelector('[data-metaobject-products-ui-config]')) || {};

      const config = {
        sectionId: root.dataset.sectionId,
        metaobjectHandle: root.dataset.metaobjectHandle,
        metaobjectType: root.dataset.metaobjectType,
        sourcePath: root.dataset.sourcePath,
        sourceSectionId: root.dataset.sourceSectionId,
        catalogScope: root.dataset.catalogScope || 'retail',
        maxProducts: Math.max(1, Number(root.dataset.maxProducts || 24)),
        enableFilters: root.dataset.enableFilters === 'true',
        hideBarAndCocoa: root.dataset.hideBarAndCocoa === 'true',
        countryProductsModeEnabled: root.dataset.countryProductsModeEnabled === 'true',
        countryProductsMode: root.dataset.countryProductsMode || 'origin',
        cardColorClass: root.dataset.cardColorClass || 'color-custom-card',
        showCardBadges: root.dataset.showCardBadges === 'true',
        showCustomBadges: root.dataset.showCustomBadges === 'true',
        showMetafieldBadges: root.dataset.showMetafieldBadges === 'true',
        showQuickAdd: root.dataset.showQuickAdd === 'true',
        showQuickAddWishlist: root.dataset.showQuickAddWishlist === 'true',
        designMode: root.dataset.designMode === 'true',
      };

      const state = {
        allProducts: [],
        matchedProducts: [],
        visibleProducts: [],
        page: 1,
        countryDisplayMode: null,
        filters: {
          makers: new Set(),
          productTypes: new Set(),
          regions: new Set(),
          estates: new Set(),
        },
        debug: {
          status: 'idle',
          pagesFetched: 0,
          totalPages: 0,
          scanned: 0,
          matched: 0,
          cardsRendered: 0,
          cardsFromSource: 0,
          cardsFallback: 0,
          usedSessionCache: false,
          error: null,
        },
      };

      function updateDebug() {
        if (!debugElement) return;
        debugElement.textContent = JSON.stringify(
          {
            config,
            debug: state.debug,
            countryDisplayMode: state.countryDisplayMode,
            page: state.page,
            visible: state.visibleProducts.length,
            firstVisibleHandles: state.visibleProducts.slice(0, 8).map((product) => product.handle),
          },
          null,
          2
        );
      }

      function setStatus(message) {
        if (!statusElement) return;
        statusElement.textContent = message || '';
        statusElement.hidden = !message;
      }

      function setEmptyState(visible) {
        if (!emptyStateElement) return;
        const heading = emptyStateElement.querySelector('h3');
        if (visible && heading && !heading.textContent.trim()) heading.textContent = uiConfig.texts?.emptyHeading || '';
        emptyStateElement.hidden = !visible;
      }

      function setSectionVisibility(visible) {
        if (config.designMode) return;
        sectionContainer.hidden = !visible;
      }

      function clearRenderedProducts() {
        itemsElement.hidden = true;
        itemsElement.innerHTML = '';
        paginationElement.hidden = true;
        paginationElement.innerHTML = '';
      }

      function showEmptyState() {
        state.matchedProducts = [];
        state.visibleProducts = [];
        setSectionVisibility(true);
        setStatus('');
        setEmptyState(true);
        clearRenderedProducts();
        if (filtersElement) filtersElement.hidden = true;
        if (countWrapperElement) countWrapperElement.hidden = true;
        if (mobileCountWrapperElement) mobileCountWrapperElement.hidden = true;
        clearAllButtons.forEach((button) => {
          button.hidden = true;
          button.classList.remove('active');
        });
      }

      function sourceUrl(page) {
        const url = new URL(config.sourcePath, window.location.origin);
        url.searchParams.set('section_id', config.sourceSectionId);
        url.searchParams.set('page', String(page));
        return url.toString();
      }

      function hasComparePrice(product) {
        if (
          typeof product?.compare_at_price_amount === 'number' &&
          typeof product?.price_amount === 'number'
        ) {
          return product.compare_at_price_amount > product.price_amount;
        }

        return Boolean(product?.compare_at_price && product.compare_at_price !== product.price);
      }

      function normalizeBadgePosition(value) {
        const rawValue = Array.isArray(value) ? value[0] : value;
        const normalized = String(rawValue || '')
          .trim()
          .toLowerCase()
          .replace(/_/g, '-')
          .replace(/\s+/g, '-');

        if (
          normalized === 'top-left' ||
          normalized === 'top-right' ||
          normalized === 'bottom-left' ||
          normalized === 'right-align-price-row'
        ) {
          return normalized;
        }

        return 'bottom-left';
      }

      function renderCardBadges(product) {
        // Use the same Liquid badge eligibility, aliases, positions, and images as every other card.
        const fragment = document.createElement('template');
        fragment.innerHTML = product?.card_badges_html || '';
        if (!config.showCardBadges) {
          fragment.content.querySelectorAll('.color-custom-badge-sale, .color-custom-badge-sold-out, .color-custom-badge-coming-soon, .product-badges__badge--new').forEach((badge) => badge.remove());
        }
        if (!config.showCustomBadges || !config.showMetafieldBadges) {
          fragment.content.querySelectorAll('.product-badges__badge--custom-metafield').forEach((badge) => badge.remove());
        }
        fragment.content.querySelectorAll('.product-badges').forEach((stack) => {
          if (!stack.children.length) stack.remove();
          else stack.setAttribute('data-metaobject-card-enhancement', '');
        });
        return fragment.innerHTML;
      }

      function renderPriceRowBadges(product) {
        return config.showCustomBadges && config.showMetafieldBadges
          ? product?.price_row_badges_html || '' : '';
      }

      function renderQuickAddMarkup(product) {
        if (!config.showQuickAdd && !config.showQuickAddWishlist) return '';

        const productId = escapeHtml(product?.id || '');
        const variantId = escapeHtml(product?.selected_or_first_available_variant_id || '');
        const quantityMinimum = Math.max(1, Number(product?.quantity_rule_min || 1));
        const handle = escapeHtml(product?.handle || '');
        const wishlistButton = config.showQuickAddWishlist
          ? `
            <div
              class="button quick-add__button quick-add__button--passport${config.showQuickAdd ? '' : ' quick-add__button--passport-only'}"
              data-bc-passport-heart-slot
              data-product-id="${productId}"
              data-bc-passport-mounted="true"
            >
              <div data-bc-heart-wrap>
                <button
                  type="button"
                  class="bc-heart-btn"
                  aria-label="${escapeHtml(uiConfig?.texts?.saveToList || 'Save to your list')}"
                  aria-pressed="false"
                  title="${escapeHtml(uiConfig?.texts?.saveToList || 'Save to your list')}"
                  data-product-id="${productId}"
                  data-variant-id="${variantId}"
                  data-handle="${handle}"
                >
                  ${uiConfig?.icons?.heart || ''}
                </button>
              </div>
            </div>
          `
          : '';

        // Native Liquid owns variant choice, minimum quantities, Best By, selling plans,
        // live announcements, and add-to-cart-component. Never rebuild that contract in JS.
        const fragment = document.createElement('template');
        fragment.innerHTML = config.showQuickAdd
          ? (product?.quick_add_html || '').replaceAll('bc-metaobject-scope', escapeHtml(config.sectionId))
          : '';
        let quickAdd = fragment.content.querySelector('quick-add-component');
        if (wishlistButton && !quickAdd) {
          quickAdd = document.createElement('div');
          quickAdd.className = 'quick-add';
          fragment.content.append(quickAdd);
        }
        if (quickAdd) {
          quickAdd.setAttribute('data-metaobject-card-enhancement', '');
          quickAdd.insertAdjacentHTML('beforeend', wishlistButton);
        }
        return fragment.innerHTML;
      }

      function renderNativeCard(product) {
        const title = escapeHtml(product?.title || product?.handle || '');
        const bestBy = product?.best_by
          ? ` <span class="best-by-date">(Best By: ${escapeHtml(product.best_by)})</span>`
          : '';
        const url = escapeHtml(product?.url || `/products/${product?.handle || ''}`);
        const ratio = escapeHtml(product?.card_ratio || '1');
        const cardConfig = uiConfig.card || {};
        const image = product?.image
          ? `
            <span class="product-media-container media-fit">
              <img
                src="${escapeHtml(product.image)}"
                alt="${escapeHtml(product.image_alt || product.title || '')}"
                loading="lazy"
              >
            </span>
          `
          : '';
        const titleClassNames = [cardConfig.titleClass || 'text-block spacing-style text-center custom-typography'];
        if (cardConfig.titlePreset === 'custom') {
          titleClassNames.push('custom-typography', 'custom-font-size', 'custom-color');
        }
        if (cardConfig.titlePreset === 'rte' || cardConfig.titlePreset === 'paragraph') {
          titleClassNames.push('rte');
        }

        const priceClassNames = [cardConfig.priceClass || 'text-block spacing-style text-center paragraph'];
        if (cardConfig.pricePreset === 'custom') {
          priceClassNames.push('custom-typography', 'custom-font-size', 'custom-color');
        }
        if (cardConfig.pricePreset === 'rte' || cardConfig.pricePreset === 'paragraph') {
          priceClassNames.push('rte');
        }

        const compareAt = hasComparePrice(product)
          ? `
            <span role="group">
              <span class="visually-hidden">${escapeHtml(uiConfig?.texts?.priceRegular || 'Regular price')}&nbsp;</span>
              <span class="compare-at-price">${escapeHtml(product.compare_at_price)}</span>
            </span>
          `
          : '';
        const price = product?.price
          ? `
            <span role="group">
              <span class="visually-hidden">${escapeHtml(uiConfig?.texts?.priceSale || 'Sale price')}&nbsp;</span>
              <span class="price">${escapeHtml(product.price)}</span>
            </span>
          `
          : '';
        const priceRowBadges = renderPriceRowBadges(product);

        return `
          <div class="metaobject-products-grid__item">
            <product-card
              class="product-card"
              data-product-id="${escapeHtml(product?.id || '')}"
              data-quick-add-wishlist-enabled="${config.showQuickAddWishlist ? 'true' : 'false'}"
            >
              <a href="${url}" class="product-card__link" ref="productCardLink">
                <span class="visually-hidden">${title}</span>
              </a>
              <div
                class="product-card__content layout-panel-flex layout-panel-flex--column product-grid__card spacing-style border-style gap-style"
                style="
                  ${escapeHtml(cardConfig.contentStyle || '--product-card-gap: 4px;')}
                  --quick-add-display: none;
                  --quick-add-mobile-display: none;
                  --quick-add-mobile-opacity: 0;
                  --quick-add-wishlist-display: none;
                "
              >
                <div class="card-gallery spacing-style" style="--gallery-aspect-ratio: ${ratio};">
                  <a class="contents" href="${url}" aria-label="${title}">
                    ${image}
                  </a>
                </div>
                <product-title class="metaobject-products-grid__product-title">
                  <a class="contents user-select-text" href="${url}">
                    <div class="${escapeHtml(titleClassNames.join(' '))}" style="${escapeHtml(cardConfig.titleStyle || '--width: 100%; --max-width: 100%;')}">
                      <p>${title}${bestBy}</p>
                    </div>
                  </a>
                </product-title>
                <product-price class="${escapeHtml(priceClassNames.join(' '))}" style="${escapeHtml(cardConfig.priceStyle || '--width: 100%;')}">
                  <div ref="priceContainer"${priceRowBadges ? ' class="product-card-price-row"' : ''}>
                    ${priceRowBadges ? '<span class="product-card-price-row__price">' : ''}
                    ${compareAt}
                    ${price}
                    ${priceRowBadges ? '</span>' : ''}
                    ${priceRowBadges}
                  </div>
                </product-price>
              </div>
            </product-card>
          </div>
        `;
      }

      function fallbackProductCard(product) {
        return renderNativeCard(product);
      }

      function decorateNativeCards(container, products) {
        if (!container) return;

        const productsById = new Map(
          (Array.isArray(products) ? products : []).map((product) => [String(product?.id || ''), product])
        );

        container.querySelectorAll('product-card.product-card').forEach((card) => {
          const product = productsById.get(String(card.dataset.productId || ''));
          if (!product) return;

          const content = card.querySelector('.product-card__content');
          const gallery = card.querySelector('.card-gallery');
          const priceContainer = card.querySelector('product-price [ref="priceContainer"]');
          if (!content || !gallery) return;

          [...content.classList]
            .filter((className) => className.startsWith('color-'))
            .forEach((className) => content.classList.remove(className));
          content.classList.add(config.cardColorClass);

          content.style.setProperty('--quick-add-display', config.showQuickAdd ? 'flex' : 'none');
          content.style.setProperty('--quick-add-mobile-display', config.showQuickAdd ? 'flex' : 'none');
          content.style.setProperty(
            '--quick-add-mobile-opacity',
            config.showQuickAdd || config.showQuickAddWishlist ? '1' : '0'
          );
          content.style.setProperty('--quick-add-wishlist-display', config.showQuickAddWishlist ? 'flex' : 'none');

          gallery.querySelectorAll('[data-metaobject-card-enhancement]').forEach((node) => node.remove());
          priceContainer?.querySelectorAll('[data-product-card-price-row-badges]').forEach((node) => node.remove());
          priceContainer?.querySelectorAll('.product-card-price-row__price[data-metaobject-price-row]').forEach((node) => {
            node.replaceWith(...node.childNodes);
          });
          priceContainer?.classList.remove('product-card-price-row');

          const enhancements = `${renderCardBadges(product)}${renderQuickAddMarkup(product)}`;
          if (enhancements) {
            gallery.insertAdjacentHTML('beforeend', enhancements);
          }

          const priceRowBadges = renderPriceRowBadges(product);
          if (priceContainer && priceRowBadges) {
            priceContainer.classList.add('product-card-price-row');
            const priceContent = document.createElement('span');
            priceContent.className = 'product-card-price-row__price';
            priceContent.dataset.metaobjectPriceRow = '';
            while (priceContainer.firstChild) {
              priceContent.appendChild(priceContainer.firstChild);
            }
            priceContainer.appendChild(priceContent);
            priceContainer.insertAdjacentHTML('beforeend', priceRowBadges);
          }
        });
      }

      function cacheKey() {
        return `${config.sourcePath}::${config.sourceSectionId}`;
      }

      function catalogStorageKey() {
        return `${CATALOG_STORAGE_PREFIX}${cacheKey()}`;
      }

      function loadCatalogFromStorage() {
        try {
          const raw = window.localStorage.getItem(catalogStorageKey());
          if (!raw) return null;
          const parsed = JSON.parse(raw);
          if (!parsed || !Array.isArray(parsed.items)) return null;
          if (!parsed.savedAt || (Date.now() - parsed.savedAt) > CATALOG_STORAGE_TTL_MS) {
            return null;
          }
          return parsed.items;
        } catch (error) {
          return null;
        }
      }

      function saveCatalogToStorage(items) {
        try {
          if (!Array.isArray(items) || !items.length) return;
          window.localStorage.setItem(
            catalogStorageKey(),
            JSON.stringify({ savedAt: Date.now(), items })
          );
        } catch (error) {
        }
      }

      function sessionKey() {
        const mode = config.metaobjectType === 'country'
          ? `${config.countryProductsModeEnabled ? config.countryProductsMode : 'auto'}`
          : 'default';
        return `${SESSION_PREFIX}${config.catalogScope}::${config.metaobjectType}::${config.metaobjectHandle}::${mode}`;
      }

      function normalizeVendorName(value) {
        return String(value || '').toLowerCase().replaceAll('&', '').replaceAll('and', '').replace(/[^a-z0-9]/g, '');
      }

      function shouldHideVendor(vendorName) {
        return config.hideBarAndCocoa && normalizeVendorName(vendorName) === 'barcocoa';
      }

      function matchesCurrentMetaobject(product) {
        if (!product || !config.metaobjectHandle || !config.metaobjectType) return false;

        if (config.metaobjectType === 'estate') {
          return product.origin_type === 'estate' && product.origin_handle === config.metaobjectHandle;
        }

        if (config.metaobjectType === 'strain') {
          const current = normalizeHandle(config.metaobjectHandle);
          return normalizeHandle(product.strain_handle) === current || normalizeHandle(product.strain_name) === current;
        }

        if (config.metaobjectType === 'country') {
          return product.derived_country_handle === config.metaobjectHandle;
        }

        return product.derived_region_handle === config.metaobjectHandle;
      }

      function resolveCountryDisplayMode(products) {
        if (config.countryProductsModeEnabled && config.countryProductsMode === 'maker') return 'made_in_country';
        if (config.countryProductsModeEnabled && config.countryProductsMode === 'origin') return 'sourced';

        if (products.some((product) => product?.derived_country_handle === config.metaobjectHandle)) return 'sourced';
        if (products.some((product) => product?.vendor_country_handle === config.metaobjectHandle)) return 'made_in_country';
        return 'none';
      }

      function getBaseMatchedProducts(allProducts) {
        const deduped = [];
        const seen = new Set();

        allProducts.forEach((product) => {
          if (!product?.id || seen.has(product.id) || shouldHideVendor(product.vendor_name)) return;
          seen.add(product.id);
          deduped.push(product);
        });

        if (config.metaobjectType !== 'country') {
          state.countryDisplayMode = null;
          return deduped.filter(matchesCurrentMetaobject);
        }

        const sourceMatches = deduped.filter((product) => product.derived_country_handle === config.metaobjectHandle);
        const makerMatches = deduped.filter((product) => product.vendor_country_handle === config.metaobjectHandle);

        state.countryDisplayMode = resolveCountryDisplayMode(deduped);

        if (config.countryProductsModeEnabled && config.countryProductsMode === 'maker') return makerMatches;
        if (config.countryProductsModeEnabled && config.countryProductsMode === 'origin') return sourceMatches;
        return sourceMatches.length > 0 ? sourceMatches : makerMatches;
      }

      function updateHeading() {
        if (!headingWrapper || !headingElement) return;
        let markup = defaultHeadingTemplate?.innerHTML?.trim() || '';

        if (config.metaobjectType === 'country') {
          if (state.countryDisplayMode === 'sourced') {
            markup = countryOriginHeadingTemplate?.innerHTML?.trim() || markup;
          } else if (state.countryDisplayMode === 'made_in_country') {
            markup = countryMakerHeadingTemplate?.innerHTML?.trim() || markup;
          }
        }

        headingWrapper.hidden = !markup;
        headingElement.innerHTML = markup;
      }

      function getFilteredProducts(options = {}) {
        const ignoredGroup = options.ignoredGroup || '';
        return state.allProducts.filter((product) => {
          if (ignoredGroup !== 'maker' && state.filters.makers.size && !state.filters.makers.has(product.vendor_name || '')) return false;
          if (ignoredGroup !== 'product_type' && state.filters.productTypes.size && !state.filters.productTypes.has(product.product_type || '')) return false;
          if (ignoredGroup !== 'region' && state.filters.regions.size && !state.filters.regions.has(product.derived_region_handle || '')) return false;
          if (
            ignoredGroup !== 'estate'
            &&
            state.filters.estates.size
            && !(product.origin_type === 'estate' && state.filters.estates.has(product.origin_handle || ''))
          ) {
            return false;
          }
          return true;
        });
      }

      function activeFilterCount() {
        return state.filters.makers.size
          + state.filters.productTypes.size
          + state.filters.regions.size
          + state.filters.estates.size;
      }

      function hasActiveFilters() {
        return activeFilterCount() > 0;
      }

      function clearAllFilters() {
        state.filters.makers.clear();
        state.filters.productTypes.clear();
        state.filters.regions.clear();
        state.filters.estates.clear();
        applyFilters();
      }

      function countBy(products, getter) {
        return products.reduce((map, product) => {
          const value = String(getter(product) || '').trim();
          if (!value) return map;
          map.set(value, (map.get(value) || 0) + 1);
          return map;
        }, new Map());
      }

      function filterValues(allProducts, countProducts, getter, labelGetter, predicate = () => true) {
        const allMap = countBy(allProducts.filter(predicate), getter);
        const countMap = countBy(countProducts.filter(predicate), getter);
        return [...allMap.keys()]
          .map((value) => ({ value, label: labelGetter(value), count: countMap.get(value) || 0 }))
          .sort((a, b) => {
            if (a.count > 0 && b.count === 0) return -1;
            if (a.count === 0 && b.count > 0) return 1;
            return a.label.localeCompare(b.label);
          });
      }

      function humanize(value) {
        return String(value || '')
          .split('-')
          .filter(Boolean)
          .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
          .join(' ');
      }

      function regionLabel(handle) {
        const product = state.allProducts.find((item) => item.derived_region_handle === handle);
        return product?.derived_region_name || humanize(handle);
      }

      function estateLabel(handle) {
        const product = state.allProducts.find((item) => item.origin_type === 'estate' && item.origin_handle === handle);
        return product?.origin_name || humanize(handle);
      }

      function buildFilterGroup(name, label, values, activeSet, placement = 'desktop') {
        if (values.length <= 1) return '';
        const activeCount = activeSet.size;
        const options = values
          .map((item, index) => {
            const id = `MetaobjectProducts-${config.sectionId}-${placement}-${name}-${index}`;
            const checked = activeSet.has(item.value);
            const disabled = item.count === 0 && !checked;
            return `
              <label class="metaobject-products-grid__filter-option${disabled ? ' metaobject-products-grid__filter-option--disabled' : ''}" for="${escapeHtml(id)}">
                <input class="metaobject-products-grid__filter-input" id="${escapeHtml(id)}" type="checkbox" value="${escapeHtml(item.value)}" data-metaobject-products-filter="${escapeHtml(name)}" ${checked ? 'checked' : ''} ${disabled ? 'disabled' : ''}>
                <span class="metaobject-products-grid__filter-box" aria-hidden="true"></span>
                <span class="metaobject-products-grid__filter-label">${escapeHtml(item.label)}</span>
                <span class="metaobject-products-grid__filter-count">(${item.count})</span>
              </label>
            `;
          })
          .join('');

        return `
          <details class="metaobject-products-grid__filter-group facets__panel facets__item" data-metaobject-products-filter-group>
            <summary class="metaobject-products-grid__filter-summary facets__summary" data-metaobject-products-filter-summary>
              <span class="metaobject-products-grid__filter-summary-label facets__label">${escapeHtml(label)}</span>
              <span class="metaobject-products-grid__filter-status-wrapper">
                <span class="metaobject-products-grid__filter-status${activeCount > 0 ? ' bubble facets__bubble' : ''}">${activeCount > 0 ? activeCount : ''}</span>
                <span class="svg-wrapper icon-caret icon-animated" aria-hidden="true">${uiConfig.icons?.caret || ''}</span>
              </span>
            </summary>
            <div class="metaobject-products-grid__filter-panel facets__panel-content details-content ${escapeHtml(uiConfig.filterColorClass || 'color-custom-filter')}">
              <div class="metaobject-products-grid__filter-options facets__inputs" data-metaobject-products-scrollable>
                ${options}
              </div>
              <div class="metaobject-products-grid__scroll-controls" data-metaobject-products-scroll-controls>
                <button type="button" class="metaobject-products-grid__scroll-button metaobject-products-grid__scroll-button--up" data-metaobject-products-scroll="up" aria-label="Scroll up" hidden>
                  <span class="svg-wrapper icon-caret">${uiConfig.icons?.caret || ''}</span>
                </button>
                <button type="button" class="metaobject-products-grid__scroll-button metaobject-products-grid__scroll-button--down" data-metaobject-products-scroll="down" aria-label="Scroll down" hidden>
                  <span class="svg-wrapper icon-caret">${uiConfig.icons?.caret || ''}</span>
                </button>
              </div>
            </div>
          </details>
        `;
      }

      function renderActiveFilters() {
        if (!activeFiltersElement) return;
        const buttons = [];
        const addButton = (group, label, value) => {
          buttons.push(`
            <button class="metaobject-products-grid__active-filter" type="button" data-metaobject-products-clear-filter="${escapeHtml(group)}" data-value="${escapeHtml(value)}">
              ${escapeHtml(label)} ×
            </button>
          `);
        };

        [...state.filters.makers].forEach((value) => addButton('maker', `Maker: ${value}`, value));
        [...state.filters.productTypes].forEach((value) => addButton('product_type', `Type: ${value}`, value));
        [...state.filters.regions].forEach((value) => addButton('region', `Region: ${regionLabel(value)}`, value));
        [...state.filters.estates].forEach((value) => addButton('estate', `Estate: ${estateLabel(value)}`, value));

        activeFiltersElement.innerHTML = buttons.join('').replaceAll('Ã—', '&times;');
        activeFiltersElement.hidden = buttons.length === 0;
        if (drawerActiveFiltersElement) {
          drawerActiveFiltersElement.innerHTML = activeFiltersElement.innerHTML;
          drawerActiveFiltersElement.hidden = activeFiltersElement.hidden;
        }
        const count = activeFilterCount();
        if (mobileActiveCountElement && mobileActiveCountTextElement) {
          mobileActiveCountTextElement.textContent = String(count);
          mobileActiveCountElement.hidden = count === 0;
        }
        clearAllButtons.forEach((button) => {
          button.hidden = count === 0;
          button.classList.toggle('active', count > 0);
        });
      }

      function renderFilters() {
        if (!filtersElement || !filterGroupsElement || !config.enableFilters) return;

        if (!state.allProducts.length) {
          filtersElement.hidden = true;
          if (filterListElement) filterListElement.innerHTML = '';
          else filterGroupsElement.innerHTML = '';
          if (drawerFilterListElement) drawerFilterListElement.innerHTML = '';
          renderActiveFilters();
          return;
        }

        const makerValues = filterValues(
          state.allProducts,
          getFilteredProducts({ ignoredGroup: 'maker' }),
          (product) => product.vendor_name,
          (value) => value
        );
        const typeValues = filterValues(
          state.allProducts,
          getFilteredProducts({ ignoredGroup: 'product_type' }),
          (product) => product.product_type,
          (value) => value
        );
        const regionValues = filterValues(
          state.allProducts,
          getFilteredProducts({ ignoredGroup: 'region' }),
          (product) => product.derived_region_handle,
          regionLabel
        );
        const estateValues = filterValues(
          state.allProducts,
          getFilteredProducts({ ignoredGroup: 'estate' }),
          (product) => product.origin_handle,
          estateLabel,
          (product) => product.origin_type === 'estate'
        );

        const showSourceFilters = !(config.metaobjectType === 'country' && state.countryDisplayMode === 'made_in_country');
        const groups = [
          buildFilterGroup('maker', 'Maker', makerValues, state.filters.makers),
          config.metaobjectType === 'country'
            ? buildFilterGroup('product_type', 'Product type', typeValues, state.filters.productTypes)
            : '',
          showSourceFilters ? buildFilterGroup('region', 'Region', regionValues, state.filters.regions) : '',
          showSourceFilters ? buildFilterGroup('estate', 'Estate', estateValues, state.filters.estates) : '',
        ].filter(Boolean);

        if (filterListElement) filterListElement.innerHTML = groups.join('');
        else filterGroupsElement.innerHTML = groups.join('');
        if (drawerFilterListElement) {
          const drawerGroups = [
            buildFilterGroup('maker', 'Maker', makerValues, state.filters.makers, 'drawer'),
            config.metaobjectType === 'country'
              ? buildFilterGroup('product_type', 'Product type', typeValues, state.filters.productTypes, 'drawer')
              : '',
            showSourceFilters ? buildFilterGroup('region', 'Region', regionValues, state.filters.regions, 'drawer') : '',
            showSourceFilters ? buildFilterGroup('estate', 'Estate', estateValues, state.filters.estates, 'drawer') : '',
          ].filter(Boolean);
          drawerFilterListElement.innerHTML = drawerGroups.join('');
        }
        filtersElement.hidden = groups.length === 0;
        renderActiveFilters();
        updateScrollButtons();
      }

      function updateScrollButtons(scope = filtersElement) {
        if (!scope) return;
        scope.querySelectorAll('[data-metaobject-products-scrollable]').forEach((scrollable) => {
          const panel = scrollable.closest('.metaobject-products-grid__filter-panel');
          const up = panel?.querySelector('[data-metaobject-products-scroll="up"]');
          const down = panel?.querySelector('[data-metaobject-products-scroll="down"]');
          if (!up || !down) return;

          const canScroll = scrollable.scrollHeight > scrollable.clientHeight + 2;
          up.hidden = !canScroll || scrollable.scrollTop <= 2;
          down.hidden = !canScroll || scrollable.scrollTop + scrollable.clientHeight >= scrollable.scrollHeight - 2;
        });
      }

      function scrollFilterOptions(button) {
        const panel = button.closest('.metaobject-products-grid__filter-panel');
        const scrollable = panel?.querySelector('[data-metaobject-products-scrollable]');
        if (!scrollable) return;

        const direction = button.dataset.metaobjectProductsScroll === 'up' ? -1 : 1;
        scrollable.scrollBy({
          top: direction * Math.max(120, Math.floor(scrollable.clientHeight * 0.75)),
          behavior: 'smooth',
        });
        window.setTimeout(() => updateScrollButtons(panel), 180);
      }

      function parseSourceResponse(html, expectedPage) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const sourceRoot = doc.querySelector('[data-metaobject-products-source]');
        if (!sourceRoot) throw new Error('Missing metaobject products source payload');

        return {
          currentPage: Number(sourceRoot.dataset.currentPage || expectedPage),
          totalPages: Number(sourceRoot.dataset.totalPages || 1),
          items: parseJsonElement(sourceRoot.querySelector('[data-metaobject-products-json]')),
        };
      }

      async function fetchSourcePage(page) {
        const response = await fetch(sourceUrl(page), { credentials: 'same-origin', headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error(`Source request failed with status ${response.status}`);
        return parseSourceResponse(await response.text(), page);
      }

      async function loadCatalogProducts(onPage) {
        const key = cacheKey();
        const cached = catalogCache.get(key);
        if (cached?.items) {
          if (typeof onPage === 'function') onPage(cached.items, { fromMemory: true });
          return cached.items;
        }
        if (cached?.promise) return cached.promise;

        const promise = (async () => {
          const firstPage = await fetchSourcePage(1);
          state.debug.totalPages = firstPage.totalPages;
          state.debug.pagesFetched = 1;

          // Keep page results slotted by page number so the final catalog is in
          // collection order (dedupe-order stable), while onPage fires in the
          // order pages resolve so first matches paint as early as possible.
          const pageBuckets = new Array(firstPage.totalPages).fill(null);
          let scanned = 0;
          function absorb(page) {
            if (!page || !Array.isArray(page.items)) return;
            const index = Math.max(1, Number(page.currentPage) || 1) - 1;
            pageBuckets[index] = page.items;
            scanned += page.items.length;
            state.debug.scanned = scanned;
            if (typeof onPage === 'function') onPage(page.items, { fromMemory: false });
          }

          absorb(firstPage);

          const pagePromises = [];
          for (let page = 2; page <= firstPage.totalPages; page += 1) {
            pagePromises.push(
              fetchSourcePage(page).then(
                (result) => {
                  state.debug.pagesFetched += 1;
                  absorb(result);
                },
                (error) => {
                  state.debug.error = error instanceof Error ? error.message : String(error);
                }
              )
            );
          }
          await Promise.all(pagePromises);

          if (itemsElement.dataset.originInitial && pageBuckets.some((page) => page === null)) {
            throw new Error('Incomplete catalog; retaining initial products.');
          }

          const collected = pageBuckets.filter(Boolean).flat();

          // Only persist a full catalog when every page succeeded; a partial
          // catalog must not poison the in-memory or localStorage caches.
          if (state.debug.pagesFetched >= firstPage.totalPages) {
            catalogCache.set(key, { items: collected });
            saveCatalogToStorage(collected);
          }
          return collected;
        })();

        catalogCache.set(key, { promise });
        try {
          return await promise;
        } catch (error) {
          catalogCache.delete(key);
          throw error;
        }
      }

      function loadSessionMatches() {
        try {
          const parsed = JSON.parse(window.sessionStorage.getItem(sessionKey()) || 'null');
          return Array.isArray(parsed?.items) ? parsed.items : null;
        } catch (error) {
          return null;
        }
      }

      function saveSessionMatches(items) {
        try {
          const sessionItems = (Array.isArray(items) ? items : []).map((item) => {
            const clone = { ...(item || {}) };
            delete clone.card_html;
            delete clone.card_html_simple;
            delete clone.card_html_native;
            return clone;
          });
          window.sessionStorage.setItem(sessionKey(), JSON.stringify({ items: sessionItems }));
        } catch (error) {
        }
      }

      function buildPagination(totalPages) {
        if (totalPages <= 1) return '';
        const currentPage = state.page;
        const pageItems = [];
        const visiblePages = new Set([1, totalPages, currentPage - 1, currentPage, currentPage + 1]);
        const normalizedPages = [...visiblePages]
          .filter((page) => page >= 1 && page <= totalPages)
          .sort((a, b) => a - b);

        let previousVisiblePage = 0;
        normalizedPages.forEach((page) => {
          if (previousVisiblePage && page - previousVisiblePage > 1) {
            pageItems.push(`
              <li class="pagination__item pagination__item--gap">
                <span class="pagination__link pagination__link--gap" aria-hidden="true">&hellip;</span>
              </li>
            `);
          }

          pageItems.push(`
            <li class="pagination__item">
              ${
                page === currentPage
                  ? `<span class="pagination__link pagination__link--page pagination__link--current" aria-current="page">${page}</span>`
                  : `<button type="button" class="pagination__link pagination__link--page" data-metaobject-products-page="${page}" aria-label="Go to page ${page}">${page}</button>`
              }
            </li>
          `);
          previousVisiblePage = page;
        });

        const prevDisabled = currentPage <= 1;
        const nextDisabled = currentPage >= totalPages;

        return `
          <nav class="pagination" aria-label="Pagination" data-current_page="${currentPage}">
            <ul class="pagination__list" role="list">
              <li class="pagination__item">
                ${
                  prevDisabled
                    ? `<span class="pagination__link pagination__link--arrow pagination__link--disabled" aria-hidden="true">
                        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M9.5 3.5 5 8l4.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                      </span>`
                    : `<button type="button" class="pagination__link pagination__link--arrow" data-metaobject-products-page="${currentPage - 1}" aria-label="Previous page">
                        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M9.5 3.5 5 8l4.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                      </button>`
                }
              </li>
              ${pageItems.join('')}
              <li class="pagination__item">
                ${
                  nextDisabled
                    ? `<span class="pagination__link pagination__link--arrow pagination__link--disabled" aria-hidden="true">
                        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M6.5 3.5 11 8l-4.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                      </span>`
                    : `<button type="button" class="pagination__link pagination__link--arrow" data-metaobject-products-page="${currentPage + 1}" aria-label="Next page">
                        <svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M6.5 3.5 11 8l-4.5 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
                      </button>`
                }
              </li>
            </ul>
          </nav>
        `;
      }

      async function renderPage(page = 1) {
        if (itemsElement.dataset.originInitial && itemsElement.contains(document.activeElement)) {
          itemsElement.addEventListener('focusout', () => {
            requestAnimationFrame(() => renderPage(page));
          }, { once: true });
          return;
        }
        delete itemsElement.dataset.originInitial;
        state.page = page;
        const filtered = getFilteredProducts();
        state.matchedProducts = filtered;
        if (countElement && countWrapperElement) {
          countElement.textContent = `${filtered.length} ${filtered.length === 1 ? 'item' : 'items'}`;
          countWrapperElement.hidden = false;
        }
        if (mobileCountElement && mobileCountWrapperElement) {
          mobileCountElement.textContent = `${filtered.length} ${filtered.length === 1 ? 'item' : 'items'}`;
          mobileCountWrapperElement.hidden = false;
        }
        const totalPages = Math.ceil(filtered.length / config.maxProducts);
        const start = (page - 1) * config.maxProducts;
        state.visibleProducts = filtered.slice(start, start + config.maxProducts);

        if (!state.visibleProducts.length) {
          setEmptyState(false);
          clearRenderedProducts();
          setStatus(state.allProducts.length ? 'No products match these filters.' : 'No products found.');
          updateDebug();
          return;
        }

        setStatus('');
        setEmptyState(false);
        itemsElement.hidden = false;
        itemsElement.innerHTML = '';

        state.debug.cardsFromSource = 0;
        state.debug.cardsFallback = 0;
        state.debug.cardsRendered = 0;

        const cards = state.visibleProducts.map((product) => {
          state.debug.cardsFallback += 1;
          return fallbackProductCard(product);
        });

        const renderedCards = cards.filter(Boolean);
        state.debug.cardsRendered = renderedCards.length;
        itemsElement.innerHTML = renderedCards.join('');
        decorateNativeCards(itemsElement, state.visibleProducts);
        paginationElement.innerHTML = buildPagination(totalPages);
        paginationElement.hidden = totalPages <= 1;
        updateDebug();
      }

      function applyFilters() {
        renderFilters();
        renderPage(1);
      }

      filtersElement?.addEventListener('change', (event) => {
        const input = event.target.closest('[data-metaobject-products-filter]');
        if (!input) return;
        if (input.disabled) return;
        const group = input.dataset.metaobjectProductsFilter;
        const value = String(input.value || '');
        const targetSet = group === 'maker'
          ? state.filters.makers
          : group === 'product_type'
            ? state.filters.productTypes
            : group === 'region'
              ? state.filters.regions
              : state.filters.estates;

        if (input.checked) targetSet.add(value);
        else targetSet.delete(value);
        applyFilters();
      });

      filtersElement?.addEventListener('click', (event) => {
        const scrollButton = event.target.closest('[data-metaobject-products-scroll]');
        if (scrollButton) {
          event.preventDefault();
          event.stopPropagation();
          scrollFilterOptions(scrollButton);
          return;
        }

        const summary = event.target.closest('[data-metaobject-products-filter-summary]');
        if (summary) {
          const currentGroup = summary.closest('[data-metaobject-products-filter-group]');
          filterGroupsElement?.querySelectorAll('[data-metaobject-products-filter-group][open]').forEach((group) => {
            if (group !== currentGroup) group.removeAttribute('open');
          });
          window.setTimeout(() => updateScrollButtons(currentGroup), 0);
          return;
        }

        const clearAll = event.target.closest('[data-metaobject-products-clear-all]');
        if (clearAll) {
          clearAllFilters();
          return;
        }

        const button = event.target.closest('[data-metaobject-products-clear-filter]');
        if (!button) return;
        const group = button.dataset.metaobjectProductsClearFilter;
        const value = String(button.dataset.value || '');
        const targetSet = group === 'maker'
          ? state.filters.makers
          : group === 'product_type'
            ? state.filters.productTypes
            : group === 'region'
              ? state.filters.regions
              : state.filters.estates;
        targetSet.delete(value);
        applyFilters();
      });

      filtersElement?.addEventListener('scroll', (event) => {
        if (event.target?.matches?.('[data-metaobject-products-scrollable]')) {
          updateScrollButtons(event.target.closest('.metaobject-products-grid__filter-panel'));
        }
      }, true);

      openDrawerButton?.addEventListener('click', () => {
        if (!drawerElement) return;
        if (typeof drawerElement.showModal === 'function') {
          drawerElement.showModal();
        } else {
          drawerElement.setAttribute('open', '');
        }
      });

      closeDrawerButton?.addEventListener('click', () => {
        drawerElement?.close();
      });

      drawerElement?.addEventListener('click', (event) => {
        if (event.target === drawerElement) drawerElement.close();
      });

      document.addEventListener('click', (event) => {
        if (root.contains(event.target)) return;
        filterGroupsElement?.querySelectorAll('[data-metaobject-products-filter-group][open]').forEach((group) => {
          group.removeAttribute('open');
        });
      });

      paginationElement?.addEventListener('click', (event) => {
        const button = event.target.closest('[data-metaobject-products-page]');
        if (!button) return;
        const page = Number(button.dataset.metaobjectProductsPage || 1);
        if (!page || page === state.page) return;
        renderPage(page);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      // Progressive-render bookkeeping. `progressiveCatalog` accumulates the raw
      // catalog items seen so far (deduped by id). state.allProducts is derived
      // from it through getBaseMatchedProducts on each render, so the exact
      // dedupe order and country-mode logic hold at every intermediate step and
      // the final pass is simply the same call over the complete catalog.
      const progressiveCatalog = [];
      const progressiveSeen = new Set();
      let progressiveRevealed = false;
      let progressiveRenderQueued = false;

      function scheduleProgressiveRender() {
        if (progressiveRenderQueued) return;
        progressiveRenderQueued = true;
        // Coalesce the near-simultaneous page resolutions into one paint.
        requestAnimationFrame(() => {
          progressiveRenderQueued = false;

          // Re-derive matches from everything seen so far. For country-auto this
          // also sets a provisional state.countryDisplayMode; the final pass
          // corrects it once the whole catalog is present.
          state.allProducts = getBaseMatchedProducts(progressiveCatalog);
          state.debug.matched = state.allProducts.length;

          if (!state.allProducts.length) {
            updateDebug();
            return;
          }

          if (!progressiveRevealed) {
            progressiveRevealed = true;
            setSectionVisibility(true);
          }
          updateHeading();
          renderFilters();
          renderPage(1);
        });
      }

      function appendProgressivePage(items) {
        if (itemsElement.dataset.originInitial) return;
        if (!Array.isArray(items) || !items.length) return;

        let added = 0;
        items.forEach((product) => {
          if (!product?.id || progressiveSeen.has(product.id)) return;
          progressiveSeen.add(product.id);
          progressiveCatalog.push(product);
          added += 1;
        });

        if (!added) return;
        scheduleProgressiveRender();
      }

      function finalizeCatalog(catalogProducts) {
        // Authoritative pass over the full catalog: preserves exact dedupe
        // order and country-mode resolution semantics.
        state.allProducts = getBaseMatchedProducts(catalogProducts);
        saveSessionMatches(state.allProducts);

        if (config.metaobjectType === 'country' && !state.countryDisplayMode) {
          state.countryDisplayMode = resolveCountryDisplayMode(state.allProducts);
        }

        state.debug.matched = state.allProducts.length;
        updateHeading();
        renderFilters();

        if (!state.allProducts.length) {
          progressiveRevealed = false;
          showEmptyState();
          updateDebug();
          return;
        }

        if (!progressiveRevealed) {
          progressiveRevealed = true;
          setSectionVisibility(true);
        }
        renderPage(1);
      }

      async function load() {
        root.setAttribute('aria-busy', 'true');
        try {
          state.debug.status = 'loading';
          if (!itemsElement.dataset.originInitial) setStatus('Loading products...');
          setEmptyState(false);
          updateDebug();

          const cachedMatches = loadSessionMatches();
          if (cachedMatches) {
            // Fast path: per-metaobject matches already computed this session.
            state.allProducts = cachedMatches;
            state.debug.usedSessionCache = true;

            if (config.metaobjectType === 'country' && !state.countryDisplayMode) {
              state.countryDisplayMode = resolveCountryDisplayMode(state.allProducts);
            }

            state.debug.status = 'loaded';
            state.debug.matched = state.allProducts.length;
            updateHeading();
            renderFilters();

            if (!state.allProducts.length) {
              showEmptyState();
              updateDebug();
              return;
            }

            setSectionVisibility(true);
            progressiveRevealed = true;
            await renderPage(1);
            state.debug.status = 'loaded';
            updateDebug();
            return;
          }

          state.debug.usedSessionCache = false;

          // Warm localStorage catalog: skip the network, still run the
          // authoritative pass so per-page session matches stay warm.
          const storedCatalog = loadCatalogFromStorage();
          if (storedCatalog) {
            catalogCache.set(cacheKey(), { items: storedCatalog });
            finalizeCatalog(storedCatalog);
            state.debug.status = 'loaded';
            updateDebug();
            return;
          }

          // Cold load: fetch pages concurrently, rendering matches as each
          // page resolves. A single failed page is logged and skipped.
          const catalogProducts = await loadCatalogProducts((pageItems) => {
            appendProgressivePage(pageItems);
          });

          finalizeCatalog(catalogProducts);

          state.debug.status = 'loaded';
          updateDebug();
        } catch (error) {
          state.debug.status = 'error';
          state.debug.error = error instanceof Error ? error.message : String(error);
          // Never wipe products that already rendered progressively.
          if (!state.allProducts.length && !itemsElement.dataset.originInitial) {
            setStatus('Products could not be loaded.');
            setEmptyState(false);
          }
          updateDebug();
        } finally {
          root.setAttribute('aria-busy', 'false');
        }
      }

      load();
    }

    function initAll(scope = document) {
      scope.querySelectorAll('[data-metaobject-products-root]').forEach(initGrid);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["origins-atlas"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initOriginsAtlas(root) {
      const cards = [...root.querySelectorAll('[data-origins-card]')];
      const groups = [...root.querySelectorAll('[data-origins-group]')];
      const search = root.querySelector('[data-origins-search]');
      const buttons = [...root.querySelectorAll('[data-origin-filter]')];
      const resultCount = root.querySelector('[data-origins-result-count]');
      const empty = root.querySelector('[data-origins-empty]');
      const initialButton = buttons.find((button) => button.getAttribute('aria-pressed') === 'true') || buttons[0];
      let activeType = initialButton?.dataset.originFilter || 'country';

      function resultLabel(count) {
        const labels = {
          country: ['country', 'countries'],
          region: ['region', 'regions'],
          estate: ['estate', 'estates'],
          blend: ['multi-origin collection', 'multi-origin collections'],
          all: ['entry', 'entries'],
        };
        const [singular, plural] = labels[activeType] || labels.all;
        return `${count} ${count === 1 ? singular : plural}`;
      }

      function update() {
        const query = search ? search.value.trim().toLowerCase() : '';
        let visibleCount = 0;

        cards.forEach((card) => {
          const type = card.dataset.originType || '';
          const haystack = card.dataset.originSearch || '';
          const matchesType = activeType === 'all' || type === activeType;
          const matchesSearch = query === '' || haystack.includes(query);
          const visible = matchesType && matchesSearch;
          card.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        groups.forEach((group) => {
          const visibleCards = group.querySelectorAll('[data-origins-card]:not([hidden])').length;
          group.hidden = visibleCards === 0;
        });

        if (resultCount) {
          resultCount.textContent = resultLabel(visibleCount);
        }

        if (empty) {
          empty.hidden = visibleCount !== 0;
        }
      }

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          activeType = button.dataset.originFilter || 'all';
          buttons.forEach((candidate) => {
            const isActive = candidate === button;
            candidate.classList.toggle('is-active', isActive);
            candidate.setAttribute('aria-pressed', String(isActive));
          });
          update();
        });
      });

      if (search) {
        search.addEventListener('input', update);
      }

      update();
    }

    function initAll(scope = document) {
      scope.querySelectorAll('[data-origins-atlas]').forEach(initOriginsAtlas);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wholesale-login"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-wholesale-login-form]');

    if (!form) return;

    event.preventDefault();

    const loginUrl = form.dataset.loginUrl || '/account/login';
    const returnUrl = form.dataset.returnUrl || '/account';
    const email = new FormData(form).get('email')?.toString().trim();
    const url = new URL(loginUrl, window.location.origin);

    url.searchParams.set('return_url', returnUrl);

    if (email) {
      url.searchParams.set('login_hint', email);
      url.searchParams.set('login_hint_mode', 'submit');
    }

    window.location.href = url.toString();
  });

  } catch(e) { console.error(e); }
})();
})();
